import React, { useState } from 'react';

import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card"
import Form from "react-bootstrap/Form";

import { fetchPOST1 } from "../apiHelper";
import { izvozObcanskaZnanostClaniceZdruzeno, izvozObcanskaZnanostClanice } from "../listOfApi";

import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

import SpinnerLoading from './SpinnerLoading';

const ReportsClanice = () => {
    const [reportButtonDisabled, setReportButtonDisabled] = useState(false);
    const [showSpinnerLoadingOZ1, setShowSpinnerLoadingOZ1] = useState(false);
    const [showSpinnerLoadingOZ2, setShowSpinnerLoadingOZ2] = useState(false);
    const [showNoDataOZ1, setShowNoDataOZ1] = useState(false);
    const [showNoDataOZ2, setShowNoDataOZ2] = useState(false);
    const [obcanskaZnanostOZ1Input, setObcanskaZnanostOZ1Input] = useState({
        datumOD: "",
        datumDO: "",
    });
    const [obcanskaZnanostOZ2Input, setObcanskaZnanostOZ2Input] = useState({
        datumOD: "",
        datumDO: "",
    });

    const exportXlsxObcanskeZnanosti1 = () => {
        setShowSpinnerLoadingOZ1(true);
        setReportButtonDisabled(true);

        fetchPOST1(`${izvozObcanskaZnanostClaniceZdruzeno}`, obcanskaZnanostOZ1Input)
        .then((data1) => {
            if (data1 !== 0) {
                const ws = XLSX.utils.json_to_sheet(data1);
                const wb = { Sheets: { projekti: ws }, SheetNames: ['projekti'] };
                const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });

                FileSaver.saveAs(data, 'izpisi_clanica_projekti_1.xlsx');

                setShowSpinnerLoadingOZ1(false);
                setReportButtonDisabled(false);
                
            } else {
                setShowSpinnerLoadingOZ1(false);
                setReportButtonDisabled(false);
                setShowNoDataOZ1(true);
                
                setTimeout(() => {
                    setShowNoDataOZ1(false);
                }, 3000);
            }
        });
    }

    const exportXlsxObcanskeZnanosti2 = () => {
        setShowSpinnerLoadingOZ2(true);
        setReportButtonDisabled(true);

        fetchPOST1(`${izvozObcanskaZnanostClanice}`, obcanskaZnanostOZ2Input)
        .then((data1) => {
            if (data1 !== 0) {
                const ws = XLSX.utils.json_to_sheet(data1);
                const wb = { Sheets: { projekti: ws }, SheetNames: ['projekti'] };
                const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });

                FileSaver.saveAs(data, 'izpisi_clanica_projekti_2.xlsx');

                setShowSpinnerLoadingOZ2(false);
                setReportButtonDisabled(false);
                
            } else {
                setShowSpinnerLoadingOZ2(false);
                setReportButtonDisabled(false);
                setShowNoDataOZ2(true);
                
                setTimeout(() => {
                    setShowNoDataOZ2(false);
                }, 3000);
            }
        });
    }

    return (
        <Container fluid>
            <Row>
                <Col className='main-header font-weight-bold'>Izpisi članice</Col>
            </Row>
            <Row>
                <Col className='header-divider'>
                    <hr />
                </Col>
            </Row>
            <Row className='mt-4'>
                <Col><b>Izpis vseh projektov članice</b></Col>
            </Row>
            <Row className='mt-2'>
                <Col>
                    <Card>
                        <Card.Body>
                            <Row className="align-items-center">
                                &nbsp;&nbsp;&nbsp;Datum od
                                <Col>
                                    <Form.Control
                                        type="date"
                                        onChange={(e) => {
                                            setObcanskaZnanostOZ1Input({
                                                ...obcanskaZnanostOZ1Input,
                                                datumOD: e.target.value
                                            });
                                        }}
                                    />
                                </Col>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Datum do
                                <Col>
                                    <Form.Control
                                        type="date"
                                        onChange={(e) => {
                                            setObcanskaZnanostOZ1Input({
                                                ...obcanskaZnanostOZ1Input,
                                                datumDO: e.target.value
                                            });
                                        }}
                                    />
                                </Col>
                                <Col></Col>
                                <Col>
                                    {showNoDataOZ1
                                        ?
                                        <div className="float-end text-end">Izvoz neuspešen.<br/>Spremenite iskalne kriterije.</div>
                                        :
                                        <Button disabled={reportButtonDisabled} className="float-end" onClick={exportXlsxObcanskeZnanosti1}>Izvozi excel</Button>
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {showSpinnerLoadingOZ1 && (
                                        <>
                                            <SpinnerLoading />
                                            <p className='text-center'>Poteka pridobivanje izpisa...</p>
                                        </>
                                    )}
                                </Col>
                                <Col>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row className='mt-4'>
                <Col><b>Izpis vseh projektov članice po partnerjih in sodelujočih članicah</b></Col>
            </Row>
            <Row className='mt-2'>
                <Col>
                    <Card>
                        <Card.Body>
                            <Row className="align-items-center">
                                &nbsp;&nbsp;&nbsp;Datum od
                                <Col>
                                    <Form.Control
                                        type="date"
                                        onChange={(e) => {
                                            setObcanskaZnanostOZ2Input({
                                                ...obcanskaZnanostOZ2Input,
                                                datumOD: e.target.value
                                            });
                                        }}
                                    />
                                </Col>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Datum do
                                <Col>
                                    <Form.Control
                                        type="date"
                                        onChange={(e) => {
                                            setObcanskaZnanostOZ2Input({
                                                ...obcanskaZnanostOZ2Input,
                                                datumDO: e.target.value
                                            });
                                        }}
                                    />
                                </Col>
                                <Col></Col>
                                <Col>
                                    {showNoDataOZ2
                                        ?
                                        <div className="float-end text-end">Izvoz neuspešen.<br/>Spremenite iskalne kriterije.</div>
                                        :
                                        <Button disabled={reportButtonDisabled} className="float-end" onClick={exportXlsxObcanskeZnanosti2}>Izvozi excel</Button>
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {showSpinnerLoadingOZ2 && (
                                        <>
                                            <SpinnerLoading />
                                            <p className='text-center'>Poteka pridobivanje izpisa...</p>
                                        </>
                                    )}
                                </Col>
                                <Col>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default ReportsClanice;